/**
 * Store admin — Products / catalog list route (Commerce, V1.0.1 M2).
 * @see docs/ecom/v1.0.1-plan.md §5.2
 */
import { createFileRoute } from "@tanstack/react-router";
import { ProductsListPage } from "../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/products/")({
  component: ProductsListPage,
});
